export enum Directions {
    ltr = 'ltr',
    rtl = 'rtl',
}

export const LANGUAGES = {
    EN: 'EN',
    HE: 'HE',
};

export const SUPPORTED_LOCALES = {
    EN: 'en-US',
    HE: 'he-IL',
};

export const EMPTY_VALUE = '---';

export const TOP_HEADER_HEIGHT = 76;
export const SIDE_MENU_WIDTH = 100;
